module.exports = __webpack_public_path__ + "static/MeteoAran-fd510cf750a794e439a295efe4b84def.png";